/**
 * @file 到達度モデル v1 のエントリポイント。
 *
 * @what: `attainment_v1.yaml` を build 時に取り込み (@rollup/plugin-yaml)、起動時に
 *   一度だけ検証して `attainmentModel` として公開する。
 * @why: UI から YAML の存在を隠し、参照は常にこの 1 箇所を通す。
 * @failure: YAML が構造要件を満たさなければ module 評価時に
 *   `AttainmentModelError` を throw する (= 壊れた表を出さずに落とす)。
 */

import rawModel from "./attainment_v1.yaml";
import { parseAttainmentModel } from "./parse";

export const attainmentModel = parseAttainmentModel(rawModel);

export * from "./types";
export { AttainmentModelError, levelById, parseAttainmentModel, unitsInCell } from "./parse";
